import React from "react";
import {useDropzone} from "react-dropzone";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {Parts, Types} from "../index";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import SignatureCanvas from "react-signature-canvas";
import {confirmAlert} from "react-confirm-alert";
import APPCONFIG from "../../constants/Config";
import TermsOfService from "./TermsOfService";

/**
 *  @property {Users_Object} state
 *  @property {object} model
 *  @property {Users_Properties} model.properties
 *  @property {Users_Is} model.is
 *  @property {Users_Has} model.has
 */

export default class DataEntry extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Users._name);
		this.update = "POST_DATAENTRY";

		this.state = {
			...this.state,
			dl_front: "",
			dl_back: "",
			w9: "",
			invalidSignature: false,
			openTOS: false
		};
		this.signatureCanvasProps = {width: 450, height: 208, className: 'sigCanvas'};
	}

	clearSigPad = () => {
		if (this.sigPad && typeof this.sigPad.clear === 'function') {
			this.sigPad.clear();
		}
	};

	getSigPadRef = (ref) => {
		this.sigPad = ref || null;
	}

	clearSigPad2 = () => {
		if (this.sigPad2 && typeof this.sigPad2.clear === 'function') {
			this.sigPad2.clear();
		}
	};

	getSigPadRef2 = (ref) => {
		this.sigPad2 = ref || null;
	}

	captureSignatureFromPad = (pad, existing) => {
		if (!pad || typeof pad.getCanvas !== 'function') {
			return existing;
		}
		if (typeof pad.isEmpty === 'function' && pad.isEmpty()) {
			return existing;
		}
		return pad.getCanvas().toDataURL('image/png');
	}

	clearSigPadRef = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clearSigPad()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	clearSigPadRef2 = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clearSigPad2()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	openModalTOS = (e) => {
		e.preventDefault();
		this.toggle("openTOS");
	}

	toggle = (modal) => {
		this.setState(prev => ({ [modal]: !prev[modal] }));
	}

	isSignatureEmpty = (pad) => !pad || typeof pad.isEmpty !== 'function' || pad.isEmpty();

	isFilled = (value) => value !== null && value !== undefined && String(value).trim() !== '';

	digitsOnly = (value) => String(value || '').replace(/\D/g, '');

	isValidTaxpayerId = (value) => {
		if (!this.isFilled(value)) return false;
		if (!/^[\d\s-]+$/.test(String(value).trim())) return false;
		const digits = this.digitsOnly(value);
		return digits.length === 9 && digits !== '000000000';
	};

	tinInputValue = (value) => String(value || '').replace(/[^\d\s-]/g, '');

	handleTinFieldChange = (field) => (event) => {
		this.setState({
			[field]: this.tinInputValue(event.target.value),
			[`${field}_error`]: '',
		});
	};

	emptyFieldErrors = () => ({
		dd_account_error: '',
		dd_routing_error: '',
		street_1_error: '',
		city_error: '',
		state_error: '',
		zip_error: '',
		tos_checkbox_error: '',
		tos_signature_error: '',
		name_error: '',
		tax_classification_error: '',
		llc_class_error: '',
		other_error: '',
		ssn_error: '',
		ein_error: '',
		w9_signature_error: '',
		dl_front_error: '',
		dl_back_error: '',
		invalidSignature: false,
		invalidSignature2: false,
	});

	applyFieldErrors = (errors) => {
		this.setState({
			...this.emptyFieldErrors(),
			...errors,
			invalidSignature2: !!errors.tos_signature_error,
			invalidSignature: !!errors.w9_signature_error,
		});
	};

	showRequiredToast = () => {
		API.Toast.error('Missing information. Please fill all required fields.', {
			position: API.Toast.POSITION.TOP_RIGHT,
		});
	};

	invalidGroupStyle = (hasError) => (hasError ? {
		border: '1px solid #d32f2f',
		borderRadius: 4,
		padding: 8,
	} : undefined);

	step1CompleteFromData = (data) => {
		if (!data) return false;
		const requiredFields = ['dd_account', 'dd_routing', 'street_1', 'city', 'state', 'zip', 'tos_checkbox'];
		if (!data.tos_signature) return false;
		return requiredFields.every((field) => !!data[field]);
	};

	step2CompleteFromData = (data) => {
		if (!data) return false;
		if (!data.name || !data.tax_classification || !data.w9_signature) return false;
		return !!(data.ssn || data.ein);
	};

	validateStep1 = (data) => {
		const errors = {};
		if (!this.isFilled(data.dd_account)) {
			errors.dd_account_error = 'Required';
		}
		if (!this.isFilled(data.dd_routing)) {
			errors.dd_routing_error = 'Required';
		} else if (this.digitsOnly(data.dd_routing).length !== 9) {
			errors.dd_routing_error = 'Routing number must be 9 digits';
		}
		['street_1', 'city', 'state', 'zip'].forEach((field) => {
			if (!this.isFilled(data[field])) {
				errors[`${field}_error`] = 'Required';
			}
		});
		if (!data.tos_checkbox) {
			errors.tos_checkbox_error = 'Required';
		}
		if (this.isSignatureEmpty(this.sigPad2) && !data.tos_signature) {
			errors.tos_signature_error = 'Signature is required';
		}
		return errors;
	};

	validateStep2 = (data) => {
		const errors = {};
		if (!this.isFilled(data.name)) {
			errors.name_error = 'Required';
		}
		if (!data.tax_classification) {
			errors.tax_classification_error = 'Required';
		}
		if (data.tax_classification === 6 && !['C', 'S', 'P'].includes(String(data.llc_class || '').toUpperCase())) {
			errors.llc_class_error = 'Enter C, S, or P';
		}
		if (data.tax_classification === 7 && !this.isFilled(data.other)) {
			errors.other_error = 'Required';
		}

		const ssn = (data && data.ssn) || this.state.ssn;
		const ein = (data && data.ein) || this.state.ein;
		const hasSsn = this.isFilled(ssn);
		const hasEin = this.isFilled(ein);
		if (!hasSsn && !hasEin) {
			errors.ssn_error = 'Enter a 9-digit SSN or EIN';
			errors.ein_error = 'Enter a 9-digit SSN or EIN';
		} else {
			if (hasSsn && !this.isValidTaxpayerId(ssn)) {
				errors.ssn_error = 'SSN must be exactly 9 digits';
			}
			if (hasEin && !this.isValidTaxpayerId(ein)) {
				errors.ein_error = 'EIN must be exactly 9 digits';
			}
		}

		if (this.isSignatureEmpty(this.sigPad) && !data.w9_signature) {
			errors.w9_signature_error = 'Signature is required';
		}
		return errors;
	};

	validateStep3 = (data) => {
		const errors = {};
		if (!data.dl_front) {
			errors.dl_front_error = 'Required';
		}
		if (!data.dl_back) {
			errors.dl_back_error = 'Required';
		}
		return errors;
	};

	handleSubmit = async (event) => {
		//this.setState({loading: true})
		if (this.state.password === '') {
			//faux setting the password on change since it is "required"
			this.state.password = 'AAAAAAAA';
		}
		if (this.lockedEmail != null) {
			this.state.email = this.lockedEmail;
		}
		if (this.props.step === 1) {
			const errors = this.validateStep1(this.state);
			if (Object.keys(errors).length > 0) {
				this.applyFieldErrors(errors);
				this.showRequiredToast();
				return;
			}
			const tos_signature = this.captureSignatureFromPad(this.sigPad2, this.state.tos_signature);
			this.state.tos_signature = tos_signature;
			this.setState({...this.emptyFieldErrors(), tos_signature});
		} else if (this.props.step === 2) {
			const errors = this.validateStep2(this.state);
			if (Object.keys(errors).length > 0) {
				this.applyFieldErrors(errors);
				this.showRequiredToast();
				return;
			}
			const w9 = JSON.stringify({
					name: this.state.name, business_name: this.state.business_name,
					tax_classification: this.state.tax_classification, llc_class: this.state.llc_class,
					street_1: this.state.street_1, city_state_zip: (this.state.city + ' ' + this.state.state + ', ' + this.state.zip),
					ein: this.state.ein, ssn: this.state.ssn, b_checkbox: this.state.b_checkbox, other: this.state.other,
					w9_signature: this.captureSignatureFromPad(this.sigPad, this.state.w9_signature)
				});
			this.state.w9 = w9;
			this.setState({...this.emptyFieldErrors(), w9});
		} else {
			const errors = this.validateStep3(this.state);
			if (Object.keys(errors).length > 0) {
				this.applyFieldErrors(errors);
				API.Toast.error('Missing files. Please upload all required files.', {
					position: API.Toast.POSITION.TOP_RIGHT,
				});
				return;
			}
			this.applyFieldErrors({});
		}

		await super.handleSubmit(event);
	}

	async afterSubmit(data, request, suppressProcess = false) {
		if (typeof (this.props.setDataSubmit) === 'function') {
			this.props.setDataSubmit();
		}

		if (typeof (this.props.setW9FilledOut) === 'function') {
			this.props.setW9FilledOut();
		}

		//this.setState({loading: false})

		if (this.props.step === 3) {
			window.location.reload();
		} else {
			this.props.setTab();
		}
	}

	/**
	 * @param {Users_Object} data
	 */
	loadSelfAfter(data) {
		this.lockedEmail = data.email;
		const dataSubmitted = this.step1CompleteFromData(data);
		const w9filledout = this.step2CompleteFromData(data);

		if (typeof (this.props.setOnboardingProgress) === 'function') {
			this.props.setOnboardingProgress({dataSubmitted, w9filledout});
		} else {
			if (dataSubmitted && typeof (this.props.setDataSubmit) === 'function') {
				this.props.setDataSubmit();
			}
			if (w9filledout && typeof (this.props.setW9FilledOut) === 'function') {
				this.props.setW9FilledOut();
			}
		}

		if (data.onboarding_message) {
			if (typeof (this.props.setOnboardingMessage) === 'function') {
				this.props.setOnboardingMessage(data.onboarding_message);
			}
		}

	};

	fileToBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = reject;
		});

	renderDropzone(label, accept, fieldName, color = "primary") {
		const Dropzone = () => {
			const {getRootProps, getInputProps, isDragActive} = useDropzone({
				onDrop: async (files) => {
					if (!files?.length) return;
					const file = files[0];
					const base64 = await this.fileToBase64(file);
					this.setState({
						[fieldName]: base64,
						[`${fieldName}_name`]: file.name,
						[`${fieldName}_error`]: '',
					});
				},
				accept,
				multiple: false,
			});

			const fileValue = this.state[fieldName];
			const fileError = this.state[`${fieldName}_error`];

			return (
				<div
					{...getRootProps()}
					style={{
						border: fileError ? "2px dashed #d32f2f" : "2px dashed #ccc",
						padding: "20px",
						borderRadius: "8px",
						textAlign: "center",
						marginBottom: "1.5rem",
						background: isDragActive ? "#f9f9f9" : "transparent",
					}}
				>
					<input {...getInputProps()} />
					<Button variant="contained" color={color}>
						{label}
					</Button>

					<div style={{marginTop: 10, color: fileError ? "#d32f2f" : "#666"}}>
						{fileError
							? fileError
							: isDragActive
								? "Drop the file here..."
								: fileValue
									? ""
									: "Drag & drop a file or click to upload"}
					</div>

					{/* ✅ PREVIEW SECTION */}
					{fileValue && (
						<div style={{marginTop: 15}}>
							<img
								src={fileValue}
								alt={label}
								style={{
									maxWidth: "100%",
									maxHeight: "200px",
									borderRadius: "8px",
									marginTop: "10px",
									objectFit: "contain",
								}}
							/>
						</div>
					)}
				</div>
			);
		};

		return <Dropzone/>;
	}


	form = () => {
		const decimalregexp = new RegExp(/\D/, 'g');
		let {properties} = this.model;
		let object = this.state;
		const loading = this.state.loading;

		if (this.props.step === 1) {
			return (
				<div style={{flexDirection: "column", display: "flex"}}>
					<h4 className="section-title">Login</h4>
					<div className={'row'}>
						<div className={'col-lg-6 col-xl-6 col-md-12 col-md-12'}>
							<div className="form-group">
								<TextField
									label="Account Email"
									value={object.email || ''}
									variant="outlined"
									margin="dense"
									fullWidth
									InputProps={{readOnly: true}}
									inputProps={{tabIndex: -1, autoComplete: 'off'}}
								/>
							</div>
						</div>
					</div>

					<h4 className="section-title">Phone</h4>
					<div className={'row'}>
						<div className={'col-lg-4 col-xl-4 col-md-12 col-md-12'}>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone_cell}
									value={object.phone_cell}
									error={object.phone_cell_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Cell Phone'}
								/>
							</div>
						</div>
						<div className={'col-lg-4 col-xl-4 col-md-12 col-md-12'}>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone_home}
									value={object.phone_home}
									error={object.phone_home_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Home Phone (optional)'}
								/>
							</div>
						</div>
						<div className={'col-lg-4 col-xl-4 col-md-12 col-md-12'}>
							<div className="form-group">
								<Framework.Elements.PhoneNumber
									property={properties.phone_work}
									value={object.phone_work}
									error={object.phone_work_error}
									update={this.handleTextFieldPropertyUpdate}
									label={'Work Phone (optional)'}
								/>
							</div>
						</div>
					</div>

					<h4 className="section-title">Direct Deposit Information</h4>
					<div className="row">
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.dd_account}
									value={object.dd_account}
									error={object.dd_account_error}
									update={this.handleTextFieldPropertyUpdate}
									label={"Account Number"}
								/>
							</div>
						</div>
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.dd_routing}
									value={object.dd_routing}
									error={object.dd_routing_error}
									update={this.handleTextFieldPropertyUpdate}
									label={"Routing Number"}
								/>
							</div>
						</div>
					</div>

					<h4 className="section-title">Address</h4>
					<Parts.Address
						object={{...this.state}}
						properties={properties}
						parent={this}
					/>
					<div className={'row d-flex justify-content-center'}>
						<div className={'justify-content-center'} style={this.invalidGroupStyle(object.tos_checkbox_error)}>
							I agree to the <a className="brand" style={{ cursor: "pointer" }} onClick={this.openModalTOS}>Terms of Service</a> and authorize direct deposits of my invoices to my account
							<div style={{textAlign: 'center'}}>
								<Checkbox
									checked={!!this.state.tos_checkbox}
									onChange={() => this.setState({tos_checkbox: !this.state.tos_checkbox, tos_checkbox_error: ''})}
								/>
							</div>
							{object.tos_checkbox_error &&
								<div style={{color: '#d32f2f', textAlign: 'center'}}>{object.tos_checkbox_error}</div>
							}
						</div>
					</div>
					<div className={'row d-flex justify-content-center'}>
						<div style={this.invalidGroupStyle(object.tos_signature_error)}>
							{/*Invalid Signature Message*/}
							{this.state.invalidSignature2 &&
								<div className="alert alert-danger" style={{marginTop: '10px', marginBottom: '10px'}}>
									<em>Signature is required</em>
								</div>
							}

							{this.state.tos_signature ? <img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/' + '/images?image=' + this.state.tos_signature}
								alt={"TOS Signature"}
								style={{
									maxWidth: "100%",
									maxHeight: "30rem",
									borderRadius: "8px",
									objectFit: "contain",
								}}
							/> : <div style={{backgroundColor: '#f2f3f4', border: object.tos_signature_error ? '2px solid #d32f2f' : 2, width: 450, height: 208}}>
								<SignatureCanvas penColor='black' canvasProps={this.signatureCanvasProps} minWidth={3}
								                 ref={this.getSigPadRef2}
								                 onEnd={() => this.setState({invalidSignature2: false, tos_signature_error: ''})}/>
							</div>}


							<Framework.Elements.LoadingSpinner isLoading={loading}/>
							<div>
								<Button disabled={loading} color="danger" onClick={() => {
									this.clearSigPadRef2();
									this.setState({invalidSignature2: false});
								}}>Clear Signature</Button>
							</div>
						</div>
					</div>
					<Modal isOpen={this.state.openTOS} toggle={() => this.toggle("openTOS")} size={"lg"}>
						<ModalHeader toggle={() => this.toggle("openTOS")}>Terms Of Service</ModalHeader>
						<ModalBody>
							<TermsOfService />
						</ModalBody>
					</Modal>
				</div>
			);
		} else if (this.props.step === 2) {
			return (
				<div style={{flexDirection: "column", display: "flex"}}>
					<h4 className="section-title">IRS Form W-9</h4>

					{/* Line 1 */}
					<div className="row">
						<div className="col-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="1. Name (as shown on your income tax return)"
									variant="outlined"
									value={this.state.name}
									error={!!this.state.name_error}
									helperText={this.state.name_error || undefined}
									InputLabelProps={{
										style: {
											fontSize: '0.8rem',
											whiteSpace: 'normal',
											lineHeight: 1.1,
										},
									}}
									onChange={(e) => this.setState({name: e.currentTarget.value, name_error: ''})}
								/>
							</div>
						</div>
					</div>

					{/* Line 2 */}
					<div className="row">
						<div className="col-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="2. Registered Business name (if different from your legal name)"
									variant="outlined"
									value={this.state.business_name}
									InputLabelProps={{
										style: {
											fontSize: '0.7rem',
											whiteSpace: 'normal',
											lineHeight: 1.1,
										},
									}}
									onChange={(e) => this.setState({business_name: e.currentTarget.value})}
								/>
							</div>
						</div>
					</div>

					{/* Line 3a & 3b */}
					<div className="row" style={{marginBottom: 10}}>
						<div className="col-lg-12 col-md-12">
							<label className="form-label">3a. Federal tax classification (check only one)</label>
							<div style={{display: "flex", flexWrap: "wrap", ...this.invalidGroupStyle(this.state.tax_classification_error)}}>
								{[
									"Individual/sole proprietor or single-member LLC",
									"C Corporation",
									"S Corporation",
									"Partnership",
									"Trust/estate",
									"Limited liability company (LLC)",
									"Other (see instructions)",
								].map((label, index) => (
									<div key={label} style={{display: "flex", alignItems: "center", width: index === 6 ? "100%" : "50%"}}>
										<Checkbox
											checked={this.state.tax_classification === (index + 1)}
											onChange={() => this.setState({
												tax_classification: (index + 1),
												tax_classification_error: '',
												llc_class_error: '',
												other_error: '',
											})}
										/>
										<span>{label}</span>
										{index === 6 && <TextField
											size="small"
											fullWidth={true}
											variant="outlined"
											disabled={this.state.tax_classification !== 7}
											value={this.state.other}
											error={!!this.state.other_error}
											helperText={this.state.other_error || undefined}
											onChange={(e) => this.setState({other: e.currentTarget.value, other_error: ''})}
										/>}
									</div>
								))}
							</div>
							{this.state.tax_classification_error &&
								<div style={{color: '#d32f2f', marginTop: 4}}>{this.state.tax_classification_error}</div>
							}
							{/* 3a sub-options for LLC classification */}
							{this.state.tax_classification === 6 && (
								<div style={{display: "flex", alignItems: "center", gap: "1rem", marginLeft: "1.5rem"}}>
									<span>Enter tax classification (C = C Corp, S = S Corp, P = Partnership):</span>
									<TextField
										size="small"
										variant="outlined"
										style={{width: "60px"}}
										value={this.state.llc_class}
										error={!!this.state.llc_class_error}
										helperText={this.state.llc_class_error || undefined}
										onChange={(e) => this.setState({
											llc_class: e.currentTarget.value.toUpperCase().replace(/[^CSP]/g, '').slice(0, 1),
											llc_class_error: '',
										})}
									/>
								</div>
							)}

							{/*	3b */}
							{([4, 5].includes(this.state.tax_classification) || (this.state.tax_classification === 6 && this.state.llc_class === 'P')) &&

								<div style={{display: "flex", alignItems: "center", width: "75%", marginBottom: 10}}>

									<span>3b. If on line 3a you checked "Partnership" or "Trust/estate", or checked "LLC" and entered "P" as its tax
										classification,
										and you are providing this form to a partnership, trust, or estate in which you have an ownership interest in,
										check this box
										if you have any foreign partners, owners, or beneficiaries.
									</span>
									<Checkbox
										checked={this.state.b_checkbox === true}
										onChange={() => this.setState({b_checkbox: !this.state.b_checkbox})}
									/>


								</div>
							}

						</div>
					</div>

					{/* Line 5 */}
					<div className="row">
						<div className="col-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="5. Address (number, street, and apt. or suite no.)"
									variant="outlined"
									value={this.state.street_1}
									disabled={true}
								/>
							</div>
						</div>
					</div>

					{/* Line 6 */}
					<div className="row">
						<div className="col-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="6. City, state, and ZIP code"
									variant="outlined"
									disabled={true}
									value={(this.state.city + ' ' + this.state.state + ', ' + this.state.zip)}
								/>
							</div>
						</div>
					</div>

					{/* Part I - TIN */}
					<h5 style={{marginTop: "1rem"}}>Part I - Taxpayer Identification Number (TIN)</h5>
					<p style={{fontSize: "0.9rem"}}>
						Enter your SSN or EIN, depending on which one you have. (EIN is if you have a registered business)
					</p>

					<div className="row">
						<div className="col-lg-6 col-md-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="Social security number (SSN)"
									variant="outlined"
									value={this.state.ssn}
									disabled={!!this.state.ein}
									error={!!this.state.ssn_error}
									helperText={this.state.ssn_error || undefined}
									inputProps={{inputMode: 'numeric', maxLength: 20}}
									onChange={this.handleTinFieldChange('ssn')}
								/>
							</div>
						</div>

						<div className="col-lg-6 col-md-12">
							<div className="form-group">
								<TextField
									fullWidth
									size="small"
									label="Employer identification number (EIN)"
									variant="outlined"
									value={this.state.ein}
									disabled={!!this.state.ssn}
									error={!!this.state.ein_error}
									helperText={this.state.ein_error || undefined}
									inputProps={{inputMode: 'numeric', maxLength: 20}}
									onChange={this.handleTinFieldChange('ein')}
								/>
							</div>
						</div>
					</div>

					{/* Part II - Certification */}
					<h5 style={{marginTop: "1rem"}}>Part II - Certification</h5>
					<p style={{fontSize: "0.9rem"}}>
						Sign below certifying items 1-4 of Part II on the Form W-9 linked <a href={"https://www.irs.gov/pub/irs-pdf/fw9.pdf"} target={"_blank"}>here</a>.
					</p>
					<div style={this.invalidGroupStyle(this.state.w9_signature_error)}>
						{/*Invalid Signature Message*/}
						{this.state.invalidSignature &&
							<div className="alert alert-danger" style={{marginTop: '10px', marginBottom: '10px'}}>
								<em>Signature is required</em>
							</div>
						}

						{this.state.w9_signature ? <img
							src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/users/' + '/images?image=' + this.state.w9_signature}
							alt={"W9 Signature"}
							style={{
								maxWidth: "100%",
								maxHeight: "30rem",
								borderRadius: "8px",
								//marginTop: "10px",
								objectFit: "contain",
							}}
						/> : <div style={{backgroundColor: '#f2f3f4', border: this.state.w9_signature_error ? '2px solid #d32f2f' : 2, width: 450, height: 208}}>
							<SignatureCanvas penColor='black' canvasProps={this.signatureCanvasProps} minWidth={3}
							                 ref={this.getSigPadRef}
							                 onEnd={() => this.setState({invalidSignature: false, w9_signature_error: ''})}/>
						</div>}


						<Framework.Elements.LoadingSpinner isLoading={loading}/>
						<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'start'}}>
							<Button disabled={loading} color="danger" onClick={() => {
								this.clearSigPadRef();
								this.setState({invalidSignature: false});
							}}>Clear Signature</Button>
						</div>
					</div>
				</div>

			)
		} else {
			return (
				<div style={{display: "flex", flexDirection: "column"}}>
					<h4 className="section-title">Upload Required Documents</h4>

					{this.renderDropzone("Upload Driver's License Front", {"image/*": []}, "dl_front", "primary")}
					{this.renderDropzone("Upload Driver's License Back", {"image/*": []}, "dl_back", "primary")}
					{/*{this.renderDropzone("Upload W9 (PDF)", {"application/pdf": []}, "w9", "primary")}*/}
				</div>
			);
		}
	};
}
